import { takeEvery, select, call, all, put } from 'redux-saga/effects';
import { ALERT_DO_ACKNOWLEDGE } from "../alerts/constants";
import serviceData from '../../services/ocularis';
import {setEvents} from "../alerts/actions";
import {triggerAcknowledgeTable} from "../layouts/actions";
import {setSelectedEvent} from "../alerts/actions";


function* parseTags(tags, newTag, token) {
    if (!newTag) return null;
    let newTagArr = newTag.split(' ');

    const ids = newTagArr.reduce((hash, newTag) => {
        const findedItem = tags.find(({name}) => name === newTag);
        if (!hash[newTag]) {
            hash[newTag] = findedItem ? findedItem.id : null
        }
        return hash
    }, {});

    const oldIds = Object.entries(ids)
        .filter(([key, val]) => val !== null)
        .map(([key, val]) => val)

    try {
        const newIdsRequest = yield all( Object.entries(ids)
            .filter(([key, val]) => val === null)
            .map(([key, val]) => call(() => serviceData.addEventTag(token, encodeURIComponent(key))))
        );

        const newTagIds = newIdsRequest.map(({data}) => data.tag_id)
            .concat(oldIds);

        if (!newTagIds.length) return null;
        return newTagIds.join(',')

    } catch(e) {
        // console.log('ERROR in adding tags to server')
    }
}

function* acknowledgeSaga(action) {
    const { token, eventsInfo } = yield select(state => state.API);
    const { selectedEvent, events, transactionId } = yield select(state => state.alerts);
    const { eventDescr } = action;
    if (!selectedEvent) return;

    const {tags, caseName, classification, comments } = eventDescr;

    const tagsIds = yield call(parseTags, eventsInfo.tags, eventDescr.tags, token);
    const caseId = eventsInfo.cases.find(({name}) => name === caseName);
    const classData = eventsInfo.classifications.find(({name}) => name === classification);
    const classId = classData ? classData.id : null;

    try {
        const ind = events.indexOf(selectedEvent);
        yield call(() => serviceData.ackEvent({token, eventId: selectedEvent.id, comment: encodeURIComponent(comments), classId, caseId: caseId && caseId.id, tagIds: tagsIds, cameraId: selectedEvent.where_id}));
        yield put(triggerAcknowledgeTable(false));

        if (ind !== -1) {
            yield put(setEvents(true,
                transactionId,
                [...events.slice(0, ind), ...events.slice(ind + 1)]
            ));
            yield put(setSelectedEvent(null))
        }

    } catch(e) {
        // console.log(e);
    }
}

export default function*() {
    yield takeEvery(ALERT_DO_ACKNOWLEDGE, acknowledgeSaga)
}